import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector   : 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls  : ['./confirm-dialog.component.scss']
})
export class FuseConfirmDialogComponent
{
    public confirmMessage: string;
    public confirmTitle = 'Confirm';
    public okTBtn = 'Yes';
    public cancelBtn = 'Cancel';

    constructor(public dialogRef: MatDialogRef<FuseConfirmDialogComponent>)
    {
    }

}



// WEBPACK FOOTER //
// ./src/@fuse/components/confirm-dialog/confirm-dialog.component.ts